module.exports = __webpack_public_path__ + "img/edge.10192644.gif";